module.exports = __webpack_public_path__ + "img/FF_Board_Web.a49e2150.png";